import { useTranslation } from "react-i18next";

export default function Safety() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto rounded-lg bg-accent-50 border border-accent-200 p-8 md:p-12">
        <div className="flex items-start gap-4">
          <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-500 text-background-50 shrink-0">
            <i className="ri-shield-star-line text-xl"></i>
          </span>
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold">{t("safety.title")}</h2>
            <p className="mt-3 text-foreground-700 leading-relaxed">{t("safety.text")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}